export const ru = {
    groups: 'В группах',
    name: 'Название',
    preview: 'Предпросмотр'
};
